const AbstractResourcesView = require("../common/AbstractResourcesView");
const Utils = require("../common/Utils");

/**
 *
 * @constructor
 * @extends {AbstractResourcesView}
 */
function FavouritesListView(launcher) {
    const self = this;
    AbstractResourcesView.call(this, launcher);

    const contentClass = "favs";
    this.getContent().attr("data-nav-icon-class", contentClass);

    const $removeButton = $('<a href="#" data-role="button" data-icon="mobile-delete" data-iconpos="notext" data-inline="true">');
    const $addButton = $('<a href="#" data-role="button" data-icon="mobile-add" data-iconpos="notext" data-inline="true">');

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "FavouritesList";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getWeight = function() {
        return 0;
    };

    // Add event handlers for add/remove favourites buttons
    $addButton.on("click", function() {
        self.publishEvent("FavouritesController", "show-add-view");
    });

    $removeButton.on("click", function() {
        self.publishEvent("FavouritesController", "show-remove-view");
    });

    const super_headerConf = this.getHeaderConfiguration;

    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return $.extend(super_headerConf(), {
            title : $.t("common::resources.filter.favs"),
            i18n : "common::resources.filter.favs",
            rightButtons : [$removeButton, $addButton],
            contentClass : contentClass
        });
    };
}

Utils.inherits(FavouritesListView, AbstractResourcesView);

module.exports = FavouritesListView;